// extracted by mini-css-extract-plugin
export default {"customButton":"button_customButton__K7CBz"};